import { render, staticRenderFns } from "./VacancyFilter.vue?vue&type=template&id=27707fff&scoped=true&"
import script from "./VacancyFilter.vue?vue&type=script&lang=js&"
export * from "./VacancyFilter.vue?vue&type=script&lang=js&"
import style0 from "./VacancyFilter.vue?vue&type=style&index=0&id=27707fff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27707fff",
  null
  
)

export default component.exports